
import ContactUs from "../../components/ContactUs";
import PlanCards from "../../components/PlanCardSection";
import SliderViewSection from "../../components/SliderViewSection";
import StayInLoop from "../../components/StayInLoop";
import TestimonialSlider from "../../components/FeedbackSlider";
import { Aurora720p, CardSwapImg } from "../../constant";
import ProductLanding from "../../components/Products/ProductLanding";
import CardCrausalView from "../../components/CardCrausalView";
import { 
  Aurora1,
 Aurora2,
 Aurora3,
 Aurora4,
 Aurora5, ProductHeroVideo } from "../../constant";


const safetyAndSustainabilityData = [
  {
    title: "Aurora. A Unified View of Workforce & Machines",
    subtitle: "Bring workforce activity, equipment status and operational workflows onto a single digital platform designed for industrial environments.",
    lists: [
      "Workforce Coordination",
      "Equipment Visibility",
      "Centralized Operations",
    ],
    mediaUrl:
      Aurora1
  },
  {
    title: "Improve Field Visibility and Workforce Coordination.",
    subtitle: "Track workforce movement, activity status and field engagement across distributed industrial operations in real time.",
    lists: [
      "Worker Location Awareness",
      "Activity Tracking",
      "Safer Field Coordination",
    ],
    mediaUrl:
      Aurora2
  },
  {
    title: "Monitor Equipment Usage Across Operations.",
    subtitle: "Capture machine runtime, utilization trends and operational behavior to improve asset availability and execution planning.",
    lists: [
      "Equipment Utilization Tracking",
      "Runtime & Idle Analysis",
      "Asset Availability Insights",
    ],
    mediaUrl:
      Aurora3
  },
  {
    title: "Turn Operational Activity into Actionable Visibility. ",
    subtitle: "Aurora creates a live operational layer connecting people, machines and industrial environments for faster situational awareness.",
    lists: [
      "Live Operational Awareness",
      "Site-Wide Activity Visibility",
      "Unified Operational Layer",
    ],
    mediaUrl:
      Aurora4
  },
  {
    title: "Scalable Infrastructure for Complex Operations.",
    subtitle: "Deploy Aurora across plants, mines, warehouses and industrial sites with flexible connectivity and centralized administration.",
    lists: [
      "Multi-Site Deployment",
      "Flexible Industrial Integration",
      "Enterprise Scalability",
    ],
    mediaUrl:
      Aurora5
  },
];




const AuroraSRPPlans = [
  {
    title: "Foundation",
    subtitle:
      "Designed for organizations beginning their connected operations journey.",
    features: [
      "Workforce Presence Monitoring",
      "Basic Equipment Tracking",
      "Operational Activity Dashboard",
      "Mobile Access",
      "Standard Reporting",
    ],
  },

  {
    title: "Connected Operations",
    subtitle:
      "Built for industrial enterprises requiring deeper operational visibility.",
    features: [
      "Workforce & Asset Coordination",
      "Equipment Utilization Analytics",
      "Multi-Site Monitoring",
      "Custom Operational Workflows",
      "Advanced Visualization Dashboards",
    ],
    popular: true,
  },

  {
    title: "Enterprise Command",
    subtitle:
      "Purpose-built for large-scale industrial ecosystems.",
    features: [
      "Unified Operations Control Layer",
      "Live Industrial Telemetry",
      "Enterprise Integrations & APIs",
      "Edge & Cloud Connectivity",
      "Centralized Administration",
      "High-Scale Infrastructure Support",
    ],
    recommended: true,
  },
];


const testimonialsData = [
  {
    quote:
      "NetZero enabled us to streamline ESG reporting and improve sustainability visibility across operations.",
    author: "General Manager, EHS",
    note: "An Integrated Energy Enterprise",
  },
  {
    quote:
      "The platform transformed our EHS processes with real-time monitoring, analytics, and actionable insights.",
    author: "Project Safety Head",
    note: "Major Oil & Gas Operator",
  },
  {
    quote:
      "Aurora helped us connect critical industrial assets and improve operational efficiency significantly.",
    author: "Project Manager",
    note: "An Integrated Oil & Gas Operator",
  },
  {
    quote:
      "We now manage compliance, audits, and sustainability reporting from a single intelligent platform.",
    author: "Head, Digital Transformation",
    note: "A Large Mining Company",
  },
  {
    quote:
      "Implementation was seamless, and the solution scaled perfectly across our enterprise operations.",
    author: "Chief Manager – Projects",
    note: "A Large Refining Company",
  },
  {
    quote:
      "The risk engagement simplified complex reporting requirements while improving data accuracy and governance.",
    author: "Chief Risk Officer",
    note: "A Large Power Generation Company",
  },
  {
    quote:
      "Connected operational intelligence and sustainability insights helped us achieve measurable business outcomes.",
    author: "Head – Projects",
    note: "One of the Largest EPC Players",
  },
  {
    quote:
      "Real-time visibility into risks, emissions, and compliance improved our overall operational performance.",
    author: "Head – Sustainability",
    note: "A Large Defence Manufacturer",
  },
  {
    quote:
      "A modern digital transformation platform that delivers measurable impact across EHS, ESG, and operations.",
    author: "Nodal Officer, Digital Initiatives",
    note: "One of the Largest Mining Operators",
  },
];

const cardData = [
  {
    title: "Edge Intelligence Powered",
    description:
      "Edge-enabled IoT devices process and transmit real-time operational data from industrial equipment, sensors and connected environments.",
  },
  {
    title: "Predictive Performance Analytics",
    description:
      "AI-driven analytics monitor machine utilization, operational efficiency and equipment health to predict failures and optimize performance.",
  },
  {
    title: "Connected Anywhere Operations",
    description:
      "Secure cloud infrastructure enables centralized monitoring, remote access and enterprise-wide visibility across industrial operations and field locations.",
  },
];

export default function ProductAurora() {
  return (
    <>
      <ProductLanding
        title={`Aurora. Connected Intelligence for Industrial Operations.`}
        subTitle={`Enable real-time monitoring of workforce activity, machine utilization and operational performance through AI-powered insights, connected devices and intelligent automation.`}
        isNetzero={false}
        url={Aurora720p}
      />
      <CardCrausalView
        title={`How Aurora Works`}
        subTitle={`Aurora leverages Industrial IoT, edge computing and intelligent analytics to capture real-time operational data from connected workers, machines and industrial assets for proactive monitoring and performance optimization.`}
        cardData={cardData}
      />

      <SliderViewSection
        title={"Aurora. Industrial Visibility Reimagined."}
        subTitle={`Aurora brings workforce activity, equipment behavior and site operations onto a unified digital layer built for modern industrial environments.`}
        data={safetyAndSustainabilityData}
      />

      <TestimonialSlider testimonials={testimonialsData} />
      <PlanCards productName = {"Aurora"} title={"Aurora Deployment Plan"} plans={AuroraSRPPlans} />
      <ContactUs />
      <StayInLoop />
    </>
  );
}
